<template>
  <div class="collections-page">
    <div class="container">
      <div class="page-header">
        <h1>Collections</h1>
        <p class="subtitle">Explore our curated collections</p>
      </div>

      <!-- Collections Grid -->
      <div v-if="collections.length > 0" class="collections-grid">
        <a
          v-for="collection in collections"
          :key="collection.id"
          :href="collection.url"
          class="collection-card"
        >
          <div v-if="collection.image || collection.banner" class="collection-image">
            <img
              :src="collection.image || collection.banner"
              :alt="collection.name"
              loading="lazy"
            />
          </div>
          <div class="collection-info">
            <h3>{{ collection.name }}</h3>
            <p v-if="collection.description" class="collection-description">
              {{ collection.description }}
            </p>
            <p class="collection-count">
              {{ collection.product_count }} {{ collection.product_count === 1 ? 'product' : 'products' }}
            </p>
          </div>
          <i class="fas fa-chevron-right arrow"></i>
        </a>
      </div>

      <!-- Empty State -->
      <div v-else class="empty-state">
        <i class="fas fa-box-open"></i>
        <h2>No Collections Available</h2>
        <p>Check back later for new collections!</p>
        <a href="/" class="btn-back">Back to Home</a>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  collections: {
    type: Array,
    required: true
  }
})
</script>
